define('app/models/reset_password',['app/setup'], function(takhfifan) {
  takhfifan.resetPassword = Backbone.Model.extend({
      validation: {
        'password': {
          required: true,
          rangeLength: [6,50],
          pattern: /^\S{6,50}$/,
          msg: i18n.t('password_invalid')
        },
        'confirmation': {
          equalTo: 'password',
          msg: i18n.t('password_different')
        },
      },
      defaults: {
        password: null,
        confirmation: null
      }
  });
});

